export default __webpack_public_path__ + "static/media/bufalo.2d5b726a.jpeg";